import { useQuery } from "react-query";
import { API_URL, APIError, APIResponse, get } from "../api";

interface IntlFlightFeatureFlags {
  enabled: boolean;
  pay_in_3_enabled: boolean;
}

/**
 * Whether the whole international-flight feature is live for customers,
 * and whether Pay-in-3 specifically is on — see
 * AppSettings::intlFlightPublicEnabled()/intlFlightBnplEnabled() on the
 * backend, which is the actual enforcement point; this just lets the UI
 * match that state instead of showing an entry point that then 403s.
 */
function useIntlFlightFeatureFlags() {
  const query = useQuery<APIResponse<IntlFlightFeatureFlags>, APIError>({
    queryKey: ["international-feature-flags"],
    queryFn: () =>
      get(`${API_URL}/aviation/international/v2/feature-flags`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      }),
    staleTime: 60_000,
  });

  return {
    flightsEnabled: query.data?.data?.enabled ?? false,
    payIn3Enabled: query.data?.data?.pay_in_3_enabled ?? false,
    isLoadingFlags: query.isLoading,
  };
}

export default useIntlFlightFeatureFlags;
